// Force inclusion of type.
// Skipping this makes the type being weird in some packages.
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../../lib-core/src/index.d.ts" />
export { default as Logo } from "./logo.svg";
export { default as MyAccountImg } from "./my-account-banner.svg";
export { default as MyCompanyAccountImg } from "./my-company-banner.svg";
export { default as MyImpersonateImg } from "./my-impersonate-banner.svg";
export { default as HappyScale } from "./footer-happy-scale.svg";
export { default as BykoPlusBlue } from "./BYKO-plus-blatt.svg";
export { default as BykoPlusWhite } from "./BYKO-plus-hvitt.svg";
